export default __webpack_public_path__ + "07757656cd4a4059a87caa9d4ab12b5e.png";